const LOOP_BUNDLE_CART_PRICE_SELECTOR =
  '.LOOP_BUNDLE_DRAWER_CONTAINER_CLASS [id^="CartBundleItem-"] > div:nth-child(3) > div:first-child span, ' +
  '.LOOP_BUNDLE_CONTAINER_CLASS [id^="CartBundleItem-"] > div:nth-child(3) > div:first-child span';

function stripAudPrefix(root = document) {
  root.querySelectorAll(LOOP_BUNDLE_CART_PRICE_SELECTOR).forEach((price) => {
    const current = price.textContent;
    const next = current.replace(/^\s*A(?=\$)/, '');
    if (next !== current) price.textContent = next;
  });
}

function initLoopBundleCartPrice() {
  stripAudPrefix();

  const observer = new MutationObserver(() => stripAudPrefix());
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}

initLoopBundleCartPrice();
